import { t } from "@ebay/i18n-ebay";
import { UK } from "../../../../../common/constants";

<div class="calculator-action-container">
  <ebay-textbox
    inputSize="regular"
    value=state.amount
    id="input-zero"
    onInput-change("updateAmount")
  >
    <@prefix-icon>
      <if(input.site === UK)>
        <ebay-pound-16-icon data-testid="uk_icon"/>
      </if>
      <else>
        <ebay-dollar-16-icon data-testid="us_icon"/>
      </else>
    </@prefix-icon>
  </ebay-textbox>

  <ebay-button
    size="large"
    variant="form"
    id="trigger-btn"
    value="Calculate"
    on-click("calculatePayments")
    type="submit"
    data-testid="trigger-btn"
  >
    ${t("calculator/index", "CALCULATE_BUTTON")}
  </ebay-button>
</div>
